<div mat-dialog-title>
  {{ settings.title }}
</div>

<div class="copy flex" mat-dialog-content>    
  <textarea
    #copyField
    class="copy__input flex-auto"
    [value]="settings.copyText"
    [rows]="rowCount">
  </textarea>
</div>

<div mat-dialog-actions>
  <button app-button buttonTheme="light" (click)="handleCancelClick()">Cancel</button>
  <button app-button buttonType="primary" (click)="handleCopyClick()">Copy to Clipboard</button>
</div>